export type GrantOpportunityEventType =
  | "status_changed"
  | "watching_changed"
  | "deadline_changed"
  | "task_created"
  | "task_completed"
  | "task_reopened"
  | "task_removed"
  | "task_assignee_changed"
  | "tasks_extracted"
  | "assignee_changed"
  | "award_updated"
  | "reviewer_added"
  | "reviewer_removed"
  | "contributor_added"
  | "contributor_removed"
  | "external_organization_linked"
  | "external_organization_unlinked"
  | "external_person_added"
  | "external_invite_requested"
  | "department_member_added"
  | "department_member_removed"
  | "scope_changed"
  | "funder_portal_updated"
  | "ai_partner_updated"
  | "artifact_generated"
  | "plan_confirmed";

export type GrantOpportunityEvent = {
  id: number;
  grant_opportunity_id: number;
  user_id: number;
  actor_name: string;
  event_type: GrantOpportunityEventType;
  metadata: Record<string, string | number | null | Record<string, number>>;
  created_at: string;
};

export async function listGrantOpportunityEvents(
  municipalityId: number,
  opportunityId: number,
): Promise<GrantOpportunityEvent[]> {
  const response = await fetch(
    `/api/v1/municipalities/${municipalityId}/grant_opportunities/${opportunityId}/events`,
    {
      credentials: "include",
      headers: { Accept: "application/json" },
    },
  );
  if (!response.ok) {
    throw new Error("Failed to load activity events");
  }
  return response.json();
}
